<template>
 <v-layout  class="page" row wrap v-if="!camdetail.id && !this.$store.state.isLoading">
      <v-flex xs12 class="text-xs-left">
        <div class="col-12 px-1 spacetop">
              <h5 class="text-dark no-wrap titlehight"> 
              </h5>
             <div  class="card-title text-center" style="width:355px;font-size: 16px;">No data found</div>
        </div>
      </v-flex>
  </v-layout>

	<v-layout  class="page page-wrap" row wrap v-else> 
	 	<v-flex xs12 class="text-xs-left">
		  <div class="col-12 px-1 spacetop"> 
        <h4 class="text-dark  card-title">
            <i class="flag-icon" title="my" id="my" v-bind:class="country_Flag(camdetail.country)"></i>
          <!-- <country-flag country='fr' size='normal' v-bind:class="country_Flag(camdetail.country)"/> --> 
          ({{camdetail.id}}) {{ camdetail.name }}
        </h4>
        <div class="text after-flag cusfont16px" ><span alt="salesperson" class="">
            {{camdetail.sales_person_name}}</span>
            <span id="lblStatus" v-bind:style="{color:filteredData(camdetail.status)}" v-model="camdetail.status"> {{filteredStatusValue(camdetail.status)}}</span>  
        </div>
        <div class="sl-date font-blue cusfont16px date">{{camdetail.start_date}} - {{camdetail.end_date}} {{camdetail.totalday}}</div>
      </div>
   	</v-flex>
  		
   	<v-flex xs12 class="text-xs-left distancerow">
		    <div class="btn-group pull-left al-left">
	          <form name="frm1" id="frm1" method="post" data-ajax="false"> 
              <router-link :to="`/?act=${act}`" v-if="$route.query.act!=null">
                <v-btn color="white" small class="btn-secondary space">
                  Back
                </v-btn>
              </router-link>
              <router-link :to="`/campaign`" v-if="!$route.query.act" > 
                <v-btn color="white" small class="btn-secondary space">
                  Back
                </v-btn>
              </router-link>
	            <!-- 
              -->
              <span v-if="isAIO && camdetail.flightscount > 0">
                <v-btn color="info"  class="space cusbuttonw" @click="openDialog($event,'verify_action',camdetail.id)"> Verify AIO</v-btn>
                <v-btn color="white" small class="btn-secondary " @click="openDialog($event,'reject_action',camdetail.id)" style="width: 80px;">Reject AIO</v-btn> 
                <Aio-Dialog v-model="verify_action" 
                      :camId="id"
                      status="verify"
                      modalTitle="verify" />
                <Aio-Dialog v-model="reject_action" 
                      :camId="id"
                      status="reject"
                      modalTitle="reject"/>   
              </span>
              
              <span v-if="isApprove && camdetail.flightscount > 0"> 
                <v-btn color="info"  class="space cusbuttonw" @click="openTestDialog($event,'approve_action',camdetail.id)">Approve</v-btn>
                <v-btn color="white" small class="btn-secondary" @click="openTestDialog($event,'lost_action',camdetail.id)">Lost</v-btn>
                <App-Dialog v-model="approve_action" 
                      :camId="id"
                      status="approve"
                      modalTitle="approve" ref="form1"/>
                <App-Dialog v-model="lost_action" 
                      :camId="id"
                      status="lost"
                      modalTitle="lost" ref="form1"/>  
              </span>
              <!-- <span v-if="`${act}=='flight_costing'`">
                  <v-btn color="info"  class="space cusbuttonw" @click="openTestDialog($event,'approve_action',camdetail.id)">Approve</v-btn>
                <v-btn color="white" small class="btn-secondary" @click="openTestDialog($event,'lost_action',camdetail.id)">Reject</v-btn>
                <App-Dialog v-model="approve_action" 
                      :camId="id"
                      status="approve"
                      modalTitle="approve" ref="form1"/>
                <App-Dialog v-model="lost_action" 
                      :camId="id"
                      status="lost"
                      modalTitle="lost" ref="form1"/>  
              </span> pull-right-->
	          </form>

	        </div>
	        <div class="btn-group btn-report-button" v-if="isAIO">
	        	<v-btn color="white" class="btn-secondary report-btn" @click.native="goReport">
			        <v-icon dark>bar_chart</v-icon>
            <!--  <i class="fa fa-bar-chart"></i>  --> Report
			      </v-btn>
	         
	        </div>
          <div class="btn-group pull-right" v-else>
            <v-btn color="white" class="btn-secondary report-btn" @click.native="goReport">
              <v-icon dark>bar_chart</v-icon>
                 Report
            </v-btn>
          </div>
	        <div class="clearfix"></div>
	   	
      </v-flex>
      <v-flex class="px-1">
      	 <!-- <v-card color="white-grey darken-2  card_2box" class="grey--text"> -->
            <div class="card-body1">
      	 	    <dl>
                <dd>Company</dd>
                <dt>{{camdetail.company}}</dt>
                <dd v-if="camdetail.agency_name">Agency</dd>
                <dt v-if="camdetail.agency_name">{{camdetail.agency_name}} </dt>
                <dd v-if="camdetail.advertiser_name">Advertiser</dd>
                <dt v-if="camdetail.advertiser_name">{{camdetail.advertiser_name}} </dt>
                <dd v-if="camdetail.aio_verified_name">AIO Verified</dd>
                <dt v-if="camdetail.aio_verified_name">{{camdetail.aio_verified_name}} {{camdetail.aio_verified_date}}</dt>
                <dd v-if="camdetail.aio_reject_remarks">AIO Reject Remark</dd>
                <dt v-if="camdetail.aio_reject_remarks">{{camdetail.aio_reject_remarks}} {{camdetail.aio_reject_remarks_date}} </dt>
                <dd>Total Sales After Discount </dd>
                <dt>{{filteredCurrency(camdetail.currency)}} {{camdetail.total_sales_before}}</dt>
                <dd>Total Sales After Agency Comm </dd>
                <dt>{{filteredCurrency(camdetail.currency)}} {{camdetail.total_sales_atfer}}</dt>
                <dd>Publisher Cost</dd>
                <dt>{{filteredCurrency(camdetail.currency)}}  {{camdetail.publisher_cost}}</dt>
                <dd>Profit Margin</dd>
                <dt>{{camdetail.profit_margin}}%</dt>
              </dl>
            </div>
      		<!--  </v-card> -->
     	 </v-flex>
    </v-layout>
   
</template>
<style scoped>
dt{
  font-weight: bold;
}

.after-flag{
   /* margin-top: 12px;
    margin-bottom: 12px;*/
    padding: 3px 0;
}

.cusbuttonw{
	width: 81px;
}
.space{
	margin-right: -3px;
	
}
.pull-right{
  margin-right: -3px;
}

i.fa{
  padding-right: 0px;
}
/*.flex.xs12{
	padding: 0px 1px 10px 7px;
}*/
.btn-report-button{
    float: right;
    margin-right: -3px;
}
.v-btn {
	 min-width: 58px;
    text-transform: capitalize !important;
    height: 36px;
    border-radius: 3px ;
    font-size: 15px;
}
.report-btn{
	 width: 81px;
}
div.btn__content {
  padding-left: 16px;
}
 .card-title{
  /*  line-height: 0% !important;*/
      display: block;
      height: auto;
}
.card-title{
     margin-bottom: .75rem;
     /* line-height: 1px !important;*/
}
div.card__title {
  padding-left: 0px;
}
</style>
<script>
  import { loginService } from '@/components/_service/Users.js'
  import { StatusColor,CurrencyCode,StatusValue } from '@/components/_service/Config.js'
  import CountryFlag from 'vue-country-flag'
  import AppDialog from '@/components/AppDialog';
  import AioDialog from '@/components/AioDialog';
  export default {
    components: {
        CountryFlag,
        AppDialog,
        AioDialog
    },
    name: 'CampaignDetail',
    data () {
      return {
      	activeColor:"#F90648",
      	status:"",
        stValue:"",
      	id: "",
      	//camdetail:[],
        country:"flag-my",
        flights:[],
        currency:"MY",
       // AIOAcess:false,
        camId:"",
        approve_action:false,
        lost_action:false,
        verify_action:false,
        reject_action:false,
        loading :true,
        act:"",
        userId:loginService.getSaleId(),       
      }
  	},
      computed: {
        isAIO(){
            if (this.camdetail.sales_person_id != this.userId) {
              if ((this.camdetail.AIOAcess == true && this.camdetail.aio_verified == 0 && this.camdetail.status =="waiting_approval") ){
                return true;
              }else
                return false;
            }else
              return false;
           
        },
        isApprove(){
          
            if (this.camdetail.sales_person_id != this.userId) {
               if ((this.camdetail.AIOAcess == true && this.camdetail.aio_verified == 1 ) && ( this.camdetail.status =="waiting_approval" || this.camdetail.status =="pending" ) ){
                 return true;
               }else
                 return false;
               
            }else
              return false;
            
            
            
        },
        camdetail(){
          return this.$store.state.camdetail;
        },
        currency1(){
          return this.$store.state.currency;
        },
        // AIOAcess(){
        //   return this.$store.state.AIOAcess;
        // }
     
    },
    methods:{
    	 getDetail () {
    		  if (this.id !==""){
              this.$store.dispatch('camDetail', this.id);
              // this.$store.commit('loading', true);
              // loginService.camdetail(this.id).then((data)=>{
              //   const cams =  data;
          
              //   this.camdetail = cams;
               
               
              //   this.$store.commit('currency',cams.currency)
              // //  this.$store.commit('checkCampaignVerifyAIOAccess',cams.AIOAcess)
              //   this.$store.commit('loading', false);

                 
                
              //  });

                
          }
    		
        },
      
      openTestDialog (e,s,n) {
          
          if (s == 'approve_action'){
            this.approve_action =true;
            this.status =s;
          }else if (s=='lost_action') {
            this.lost_action = true
            this.status =s;
          }
      },
      openDialog(e,s,n){
         if(s=='verify_action'){
              this.verify_action = true;
              this.status = s
          }else if(s=='reject_action'){
              this.reject_action = true
              this.status = s
          }
          this.camId = n

      },
       filteredStatusValue(status){
          
            Object.keys(StatusValue).forEach(key => {
              const item =  StatusValue[key]
            
              if (status == key){
                this.stValue = item
              }
            })  
            return this.stValue;
         }, 
       
        filteredData(status){
      			Object.keys(StatusColor).forEach(key => {
    			  	const item =  StatusColor[key]
    			 	
      			 	if (status == key){
      			 	 	this.activeColor = item
      			 	}
    			  })  
      			return this.activeColor;
  		  },
        filteredCurrency(currency){
            Object.keys(CurrencyCode).forEach(key => {
              const item =  CurrencyCode[key]
             
              if (currency == key){
                this.currency = item
              }
            })  
            return this.currency;
        },
        country_Flag(ctry){
             if (ctry){
                return "flag-icon-"+ctry
             }else
                return this.country
        },
        goReport(){
           this.$router.push({ name: 'reportfull', params: { id:  this.$route.params.id }})
        },
        backTo(){
            if (this.act){
                this.$router.go('/')
                //this.$router.push({path:"/",query: { act: this.act } })
            }else{
               this.$router.go('/campaign')
                //this.$router.push({ path: '/campaign'})
            }
       }

    },
    updated(){
      if (this.camdetail){
        localStorage.setItem("camdetailstore", JSON.stringify(this.camdetail));
      }else
        localStorage.setItem("camdetailstore",null);
      
    },
    created(){
    //  this.getDetail()
    },
    mounted(){
     // console.log(this.$store.state.isLoading)
    //
       this.getDetail()
     //  localStorage.setItem("camdetailstore", null);
   //   console.log(this.camdetail)
      if (this.$route.query.act){
         this.act = this.$route.query.act
      //  
      }
    },
  	 beforeMount(){

  		this.id = this.$route.params.id
  
  	},
    watch: {
       approve_action(val) {
          if (val){
              this.$refs.form1[0];
            }
        },
        lost_action(val){
           if (val){
              this.$refs.form1[0];
            }
        }
     
    },
  

   }
 </script>